module.exports = __webpack_public_path__ + "img/logo.5a2c7a4c.png";